const SuggestionType = {
  SUGGESTION: 'SUGGESTION',
  CATEGORY: 'CATEGORY',
  PRODUCT: 'PRODUCT'
};

export default SuggestionType;



// WEBPACK FOOTER //
// ./src/types/SuggestionType.js